const assetUrl = "http://localhost:3001";
const constant = {
  assetUrl: assetUrl,
  assetImageUrl: assetUrl + "/images",
  adminRoles: ["ADMIN"],
  customerRoles: ["CUSTOMER"],
};

export default constant;
